'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validators = require('vuelidate/lib/validators');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            username: '',
            password: ''
        };
    },
    validations: {
        username: {
            required: _validators.required,
            email: _validators.email,
            minLength: (0, _validators.minLength)(2)
        },
        password: {
            required: _validators.required,
            minLength: (0, _validators.minLength)(8)
        }

    },
    computed: {
        usernameClass: function usernameClass() {
            return {
                'form-group--error': this.$v.username.$error,
                'form-group--valid': this.$v.username.$dirty && !this.$v.username.$error
            };
        },
        passwordClass: function passwordClass() {
            return {
                'form-group--error': this.$v.password.$error,
                'form-group--valid': this.$v.password.$dirty && !this.$v.password.$error
            };
        }
    },
    methods: {
        checkField: _lodash2.default.debounce(function (fieldName, $event) {
            if ($event.target.value.length === 0) {
                this.$v[fieldName].$reset();
            } else {
                this.$v[fieldName].$touch();
            }
        }, 500)
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/login.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/login.vue
// module chunks = 0